import React, { useEffect } from 'react';
import { ENTER } from '../ISRConstants';

type TFractionalInputProps = {
    id: string;
    fieldName: string;
    value: string | number | undefined;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    errors: { [key: string]: string | null };
    setErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string | null }>>;
}

const FractionalInput = ({id, fieldName, value, handleInputChange, errors, setErrors }: TFractionalInputProps) => {
    
    useEffect(() => {
        validateFractionalValue();
    }, [value]);

    const validateFractionalValue = () => {
        const regex = /^\d+$|^\d+\s*\/\s*(?!\d+$)\d+$|^\d+(?:\s+\d*)?\/\d+$|^\d+-\d+\s*\/\s*\d+$/;
        const errorMessage = value && !regex.test(value.toString()) ? 'Invalid fraction' : null;
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    };
    
    return (
        <div id={id}>
            <div id={`${id}-container`} className="tw-flex tw-items-center">
                <input
                    id={`${id}-input`}
                    type="text"
                    value={value}
                    onChange={handleInputChange}
                    placeholder={ENTER}
                    className="input-field-dm"
                />
            </div>
        </div>
    );
};

export default FractionalInput;
